import { ProgressBar } from "@/design-system/ProgressBar/ProgressBar";
import { cn } from "@/lib/utils";
import { topToPageSelector } from "@/redux/globalState/globalStateSlice";
import { StreamlineTotals } from "@repo/shared/streamline";
import { useSelector } from "react-redux";

import { AddPlayerButton } from "./AddPlayerButton";
import { PointsCounter } from "./PointsCounter";

/** Desktop: the progress line over the player rows, beside the side rail. */
export const StreamlineDesktopHeader = ({
  totals,
  minPoints,
  onCommitProgress,
  onAddPlayer,
  addedCount = 0,
  loading = false,
}: {
  totals: StreamlineTotals;
  minPoints: number;
  onCommitProgress: (points: number) => void;
  onAddPlayer: () => void;
  addedCount?: number;
  loading?: boolean;
}) => {
  // The nav is sticky at z-40, so the progress line has to stop below it.
  const topToPage = useSelector(topToPageSelector);
  return (
    <div
      className={cn(
        "sticky z-30 flex items-center gap-4 bg-background px-6.5 pt-5.5 pb-4.5",
        topToPage.tailwindString,
      )}
    >
      <ProgressBar ratio={totals.progress} className="max-w-[460px]" />
      <PointsCounter
        earned={totals.pointsEarned}
        target={totals.targetPoints}
        min={minPoints}
        onCommitProgress={onCommitProgress}
        loading={loading}
      />
      <AddPlayerButton
        onClick={onAddPlayer}
        count={addedCount}
        disabled={loading}
      />
    </div>
  );
};
